import { useEffect } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const STORAGE_KEY = "utm_params";

export function getUTMParams() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function useUTMTracking() {
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const utm = {};
      let found = false;

      UTM_KEYS.forEach((key) => {
        const value = params.get(key);
        if (value) {
          utm[key] = value;
          found = true;
        }
      });

      if (found) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
      }
    } catch {
      // silently fail if sessionStorage is unavailable
    }
  }, []);
}
